/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const getReviewerPerformanceBreakdownV1QuerySchema = z.object({
  userId: z.string().min(1),
  days: z.coerce.number().int().min(1).max(90).default(30),
});

export type IGetReviewerPerformanceBreakdownV1Query = z.input<
  typeof getReviewerPerformanceBreakdownV1QuerySchema
>;
